/**
 * CORBACI WEBSITE - IMAGE CONFIGURATION (LOCAL VERSION)
 * 
 * HOW TO UPDATE IMAGES:
 * 1. Put your image files in the /public/images/ folder:
 *    - Hero background → /public/images/hero/
 *    - Gallery photos → /public/images/gallery/
 *    - About photos → /public/images/about/
 *    - Logo → /public/images/
 * 
 * 2. Update the filename in this file
 * 3. Save and rebuild: yarn build
 * 4. Push to GitHub → Vercel auto-deploys!
 * 
 * RECOMMENDED IMAGE SIZES:
 * - Hero: 1920x1080px (landscape, JPG)
 * - Gallery: 800x800px (square, JPG)
 * - About: 600x800px (portrait, JPG)
 * - Logo: 400x160px (landscape, PNG with transparent background)
 * 
 * FOLDER STRUCTURE:
 * public/
 *   images/
 *     hero/
 *       background.jpg          ← Hero background image
 *     gallery/
 *       image-1.jpg             ← Gallery images (8 total)
 *       image-2.jpg
 *       ...
 *     about/
 *       image-1.jpg             ← About section images (4 total)
 *       ...
 *     logo.png                  ← Restaurant logo
 */

export const websiteImages = {
  // HERO SECTION (Main background image)
  // File location: /public/images/hero/background.jpg
  hero: {
    background: "/images/hero/background.jpg",
    alt: "Corbaci Restaurant Front"
  },

  // GALLERY SECTION (8 images displayed in grid)
  // File location: /public/images/gallery/image-1.jpg, image-2.jpg, etc.
  gallery: [
    {
      url: "/images/gallery/image-1.jpg",
      alt: "Turkish dishes"
    },
    {
      url: "/images/gallery/image-2.jpg",
      alt: "Grilled specialties"
    },
    {
      url: "/images/gallery/image-3.jpg",
      alt: "Traditional meal"
    },
    {
      url: "/images/gallery/image-4.jpg",
      alt: "Main course"
    },
    {
      url: "/images/gallery/image-5.jpg",
      alt: "Turkish cuisine"
    },
    {
      url: "/images/gallery/image-6.jpg",
      alt: "Tea and meze"
    },
    {
      url: "/images/gallery/image-7.jpg",
      alt: "Roasted dish"
    },
    {
      url: "/images/gallery/image-8.jpg",
      alt: "Bread making"
    }
  ],

  // ABOUT SECTION (4 images in grid)
  // File location: /public/images/about/image-1.jpg, image-2.jpg, etc.
  about: [
    {
      url: "/images/about/image-1.jpg",
      alt: "Traditional Turkish cooking"
    },
    {
      url: "/images/about/image-2.jpg",
      alt: "Home cooking"
    },
    {
      url: "/images/about/image-3.jpg",
      alt: "Authentic preparation"
    },
    {
      url: "/images/about/image-4.jpg",
      alt: "Fresh ingredients"
    }
  ],

  // LOGO (Header & Footer logo)
  // File location: /public/images/logo.png
  logo: {
    url: "/images/logo.png",
    alt: "Corbaci Logo"
  }
  // RECOMMENDED: 400x160px, PNG format with transparent background
  // This logo appears in both header and footer
};

// Helper function to get image by key
export const getImage = (section, index = null) => {
  if (index !== null) {
    return websiteImages[section][index];
  }
  return websiteImages[section];
};
